// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "1dca2c6d53edc4053bc5f4cdcab3f2d7" + ".js";
};